export const formatShortAddress = (address: string, first: number = 4, last: number = 4) => {
  return `${address.substring(0, first)}...${address.substring(address.length - last)}`;
};
